module.exports = __webpack_public_path__ + "static/img/14000735.4e078f6f.png";